import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
  estates: null,
};

const actions = (set, get) => ({
  // SET estates after fetching
  setEstates: estateList => set({ estates: estateList }),

  getEstateById: id => {
    const { estates } = get();
    return estates?.find(estate => estate.id === id);
  },

  getAllEstates: () => {
    return get().estates;
  },
});

export const useEstateStore = create(
  devtools(
    (set, get) => ({
      ...initialState,
      ...actions(set, get),
    }),
    { name: 'EstateStore' }
  )
);
